import { HackleAppInvocator } from "./HackleAppInvocator"
import { AsyncInvocation, SyncInvocation } from "./Invocation"

export class HackleAppInvocationProcessor {
  constructor(
    private readonly syncInvocator: HackleAppInvocator,
    private readonly asyncInvocator: HackleAppInvocator
  ) {}

  process<P extends Record<string, any> | never, R>(invocation: SyncInvocation<P, R>): R | undefined {
    return this.syncInvocator.process(invocation)
  }

  processAsync<P extends Record<string, any> | never>(invocation: AsyncInvocation<P>): Promise<void> | undefined {
    return this.asyncInvocator.process<P, Promise<void>>(invocation)
  }
}
